/**
 * Normalizes all <img> tags for API. Keeps only `src` and `alt`.
 * Removes style, width, height, class, srcset, and any other attributes.
 *
 * @param {string|null|undefined} html
 * @returns {string|null|undefined}
 */
export function sanitizeRichTextHtmlForApi(html) {
  if (html == null || html === "") {
    return html;
  }
  if (typeof html !== "string") {
    return html;
  }

  const doc = new DOMParser().parseFromString(
    `<div class="sanitize-rich-text-root">${html}</div>`,
    "text/html",
  );
  const root = doc.querySelector(".sanitize-rich-text-root");
  if (!root) {
    return html;
  }

  root.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");
    const alt = img.getAttribute("alt");

    while (img.attributes.length > 0) {
      img.removeAttribute(img.attributes[0].name);
    }

    if (src != null && src !== "") {
      img.setAttribute("src", src);
    }
    if (alt != null) {
      img.setAttribute("alt", alt);
    }
  });

  return root.innerHTML;
}
